import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function StatsSection() {
  const {
    t
  } = useLanguage();
  const stats = t.stats.items;
  return <section className="w-full bg-lightGray py-24" data-id="element-122">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-123">
        <h2 className="text-center text-3xl font-poppins font-bold text-navy mb-12" data-id="element-124">
          {t.stats.heading}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-125">
          {stats.map((stat, index) => <div key={index} className="bg-white border border-borderColor rounded-xl py-10 px-6 flex flex-col items-center justify-center text-center shadow-[0_2px_10px_-4px_rgba(0,0,0,0.05)]" data-id="element-126">
              <div className="text-brandOrange text-[40px] font-poppins font-bold mb-2 leading-none" data-id="element-127">
                {stat.value}
              </div>
              <div className="text-gray-500 text-sm font-medium" data-id="element-128">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}